import type { ReactElement } from 'react';

export function getInventoryStatus(
  stock: number,
  usageRatePerWeek: number,
  weeksCoveredBeforeUrgent: number,
  weeksCoveredBeforeMonitor: number,
  t: (key: string) => string
): ReactElement {
  const weeksCovered =
    usageRatePerWeek > 0 ? stock / usageRatePerWeek : Infinity;

  if (weeksCovered <= weeksCoveredBeforeUrgent) {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium text-error-700 bg-error-100">
        {t('inventory.urgent')}
      </span>
    );
  }

  if (weeksCovered <= weeksCoveredBeforeMonitor) {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium text-warning-700 bg-warning-100">
        {t('inventory.soon')}
      </span>
    );
  }

  return (
    <span className="px-2 py-1 rounded-full text-xs font-medium bg-success-100 text-success-700">
      {t('inventory.healthy')}
    </span>
  );
}

export const isNonNegativeNumber = (v: number | ''): boolean =>
  v !== '' && !Number.isNaN(v) && v >= 0;
